import { render, staticRenderFns } from "./PuiDocumentNotificacionGrid.vue?vue&type=template&id=1411f465"
import script from "./PuiDocumentNotificacionGrid.vue?vue&type=script&lang=js"
export * from "./PuiDocumentNotificacionGrid.vue?vue&type=script&lang=js"
import style0 from "./PuiDocumentNotificacionGrid.vue?vue&type=style&index=0&id=1411f465&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports